import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a67d18e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wizard px-6 py-6" }
const _hoisted_2 = { class: "head-wrapper" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "wizard-progress" }

type Props = {
  title: string
  progress?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Wizard',
  props: {
    title: {},
    progress: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "progress",
        style: _normalizeStyle({
          width: _ctx.progress + '%',
        }),
        "data-testid": "progress"
      }, null, 4 /* STYLE */)
    ])
  ]))
}
}

})